const routes = [
  {
    path: "/",
    name: "dashboard",
    redirect: "/Reports/view",
    // Adding meta for the initial dashboard/home link
    meta: {
      breadcrumb: "menu.Dashboard", // Use i18n key for Dashboard
      breadcrumbIcon: "home", // Unicon icon: 'home'
    },
  },
  {
    path: "/locations",
    // No direct component for '/locations' itself, it's a parent for children
    // If you want 'Locations' to be a clickable breadcrumb, add meta here:
    meta: {
      breadcrumb: "menu.manage_locations", // Use i18n key for Locations
      breadcrumbIcon: "map-marker-alt", // Unicon icon: 'map-marker-alt'
    },
    component: () =>
      import(/* webpackChunkName: "axios" */ "@/view/crud/Locations/Index.vue"),
    children: [
      {
        path: "view",
        name: "locations-view",
        component: () =>
          import(
            /* webpackChunkName: "locations" */ "@/view/crud/Locations/View.vue"
          ),
        meta: {
          breadcrumb: "menu.manage_locations", // Use i18n key for "View All"
        },
      },
      {
        path: "edit/:id",
        name: "locations-edit",
        component: () =>
          import(
            /* webpackChunkName: "edit-service" */ "@/view/crud/Locations/edit.vue"
          ),
        meta: {
          // You can still use a function for dynamic parts, and then append the ID.
          // The base "Edit Location" part would be an i18n key.
          breadcrumb: (route) => `menu.EditLocation:${route.params.id}`, // Example of combining i18n key with dynamic param
          breadcrumbIcon: "edit", // Unicon icon: 'edit'
        },
      },
      {
        path: "add/",
        name: "locations-add",
        component: () =>
          import(
            /* webpackChunkName: "locations-add" */ "@/view/crud/Locations/addNew.vue"
          ),
        meta: {
          breadcrumb: "menu.add_location", // Use i18n key for "Add New"
          breadcrumbIcon: "plus", // Unicon icon: 'plus'
        },
      },
    ],
  },

  {
    path: "/Reports",
    meta: {
      breadcrumb: "menu.Reports", // Use i18n key for Reports
      breadcrumbIcon: "chart-bar", // Unicon icon: 'chart-bar'
    },
    component: () =>
      import(/* webpackChunkName: "axios" */ "@/view/crud/Reports/Index.vue"),
    children: [
      {
        path: "view",
        name: "reports-view",
        component: () =>
          import(
            /* webpackChunkName: "Reports" */ "@/view/crud/Reports/View.vue"
          ),
        meta: {
          breadcrumb: "menu.ViewAll",
        },
      },
      {
        path: "edit/:id",
        name: "reports-edit",
        component: () =>
          import(
            /* webpackChunkName: "edit-service" */ "@/view/crud/Reports/edit.vue"
          ),
        meta: {
          breadcrumb: (route) => `menu.EditReport:${route.params.id}`,
          breadcrumbIcon: "edit",
        },
      },
      {
        path: "add/",
        name: "reports-add",
        component: () =>
          import(
            /* webpackChunkName: "Reports-add" */ "@/view/crud/Reports/addNew.vue"
          ),
        meta: {
          breadcrumb: "menu.AddNew",
          breadcrumbIcon: "plus",
        },
      },
    ],
  },

  {
    path: "/LocationNotes/:location_id/",
    meta: {
      // Dynamic breadcrumb for the parent route based on location_id
      breadcrumb: (route) =>
        `menu.NotesForLocation:${route.params.location_id}`, // Example dynamic i18n key
      breadcrumbIcon: "clipboard-alt", // Unicon icon: 'clipboard-alt' (common alternative for clipboard)
    },
    component: () =>
      import(
        /* webpackChunkName: "axios" */ "@/view/crud/LocationNotes/Index.vue"
      ),
    children: [
      {
        path: "view",
        name: "locationnotes-view",
        component: () =>
          import(
            /* webpackChunkName: "LocationNotes" */ "@/view/crud/LocationNotes/View.vue"
          ),
        meta: {
          breadcrumb: "menu.ViewAll",
        },
      },
      {
        path: "edit/:id",
        name: "locationnotes-edit",
        component: () =>
          import(
            /* webpackChunkName: "edit-service" */ "@/view/crud/LocationNotes/edit.vue"
          ),
        meta: {
          breadcrumb: (route) => `menu.EditNote:${route.params.id}`,
          breadcrumbIcon: "edit",
        },
      },
      {
        path: "add/",
        name: "locationnotes-add",
        component: () =>
          import(
            /* webpackChunkName: "LocationNotes-add" */ "@/view/crud/LocationNotes/addNew.vue"
          ),
        meta: {
          breadcrumb: "menu.AddNew",
          breadcrumbIcon: "plus",
        },
      },
    ],
  },

  {
    path: "/Notes",
    meta: {
      breadcrumb: "menu.Notes", // Use i18n key for Notes
      breadcrumbIcon: "sticky-note", // Unicon icon: 'sticky-note'
    },
    component: () =>
      import(/* webpackChunkName: "axios" */ "@/view/crud/Notes/Index.vue"),
    children: [
      {
        path: "view",
        name: "notes-view",
        component: () =>
          import(/* webpackChunkName: "Notes" */ "@/view/crud/Notes/View.vue"),
        meta: {
          breadcrumb: "menu.ViewAll",
        },
      },
      {
        path: "edit/:id",
        name: "notes-edit",
        component: () =>
          import(
            /* webpackChunkName: "edit-service" */ "@/view/crud/Notes/edit.vue"
          ),
        meta: {
          breadcrumb: (route) => `menu.EditNote:${route.params.id}`,
          breadcrumbIcon: "edit",
        },
      },
      {
        path: "add/",
        name: "notes-add",
        component: () =>
          import(
            /* webpackChunkName: "Notes-add" */ "@/view/crud/Notes/addNew.vue"
          ),
        meta: {
          breadcrumb: "menu.AddNew",
          breadcrumbIcon: "plus",
        },
      },
    ],
  },

  {
    path: "/Notifications",
    meta: {
      breadcrumb: "menu.Notifications", // Use i18n key for Notifications
      breadcrumbIcon: "bell", // Unicon icon: 'bell'
    },
    component: () =>
      import(
        /* webpackChunkName: "axios" */ "@/view/crud/Notifications/Index.vue"
      ),
    children: [
      {
        path: "view",
        name: "notifications-view",
        component: () =>
          import(
            /* webpackChunkName: "Notifications" */ "@/view/crud/Notifications/View.vue"
          ),
        meta: {
          breadcrumb: "menu.ViewAll",
        },
      },
    ],
  },

  {
    path: "/NoteReplies/:note_id/",
    meta: {
      breadcrumb: (route) => `menu.RepliesForNote:${route.params.note_id}`, // Dynamic i18n key
      breadcrumbIcon: "reply", // Unicon icon: 'reply'
    },
    component: () =>
      import(
        /* webpackChunkName: "axios" */ "@/view/crud/NoteReplies/Index.vue"
      ),
    children: [
      {
        path: "view",
        name: "notereplies-view",
        component: () =>
          import(
            /* webpackChunkName: "NoteReplies" */ "@/view/crud/NoteReplies/View.vue"
          ),
        meta: {
          breadcrumb: "menu.ViewAll",
        },
      },
      {
        path: "edit/:id",
        name: "notereplies-edit",
        component: () =>
          import(
            /* webpackChunkName: "edit-service" */ "@/view/crud/NoteReplies/edit.vue"
          ),
        meta: {
          breadcrumb: (route) => `menu.EditReply:${route.params.id}`,
          breadcrumbIcon: "edit",
        },
      },
      {
        path: "add/",
        name: "notereplies-add",
        component: () =>
          import(
            /* webpackChunkName: "NoteReplies-add" */ "@/view/crud/NoteReplies/addNew.vue"
          ),
        meta: {
          breadcrumb: "menu.AddNew",
          breadcrumbIcon: "plus",
        },
      },
    ],
  },

  {
    path: "/Courses",
    meta: {
      breadcrumb: "menu.Courses", // Use i18n key for Courses
      breadcrumbIcon: "book", // Unicon icon: 'book'
    },
    component: () =>
      import(/* webpackChunkName: "axios" */ "@/view/crud/Courses/Index.vue"),
    children: [
      {
        path: "view",
        name: "courses-view",
        component: () =>
          import(
            /* webpackChunkName: "Courses" */ "@/view/crud/Courses/View.vue"
          ),
        meta: {
          breadcrumb: "menu.ViewAll",
        },
      },
      {
        path: "edit/:id",
        name: "courses-edit",
        component: () =>
          import(
            /* webpackChunkName: "edit-service" */ "@/view/crud/Courses/edit.vue"
          ),
        meta: {
          breadcrumb: (route) => `menu.EditCourse:${route.params.id}`,
          breadcrumbIcon: "edit",
        },
      },
      {
        path: "add/",
        name: "courses-add",
        component: () =>
          import(
            /* webpackChunkName: "Courses-add" */ "@/view/crud/Courses/addNew.vue"
          ),
        meta: {
          breadcrumb: "menu.AddNew",
          breadcrumbIcon: "plus",
        },
      },
    ],
  },

  {
    path: "/Tools",
    meta: {
      breadcrumb: "menu.Tools", // Use i18n key for Tools
      breadcrumbIcon: "tools", // Unicon icon: 'tools'
    },
    component: () =>
      import(/* webpackChunkName: "axios" */ "@/view/crud/Tools/Index.vue"),
    children: [
      {
        path: "view",
        name: "tools-view",
        component: () =>
          import(/* webpackChunkName: "Tools" */ "@/view/crud/Tools/View.vue"),
        meta: {
          breadcrumb: "menu.ViewAll",
        },
      },
      {
        path: "edit/:id",
        name: "tools-edit",
        component: () =>
          import(
            /* webpackChunkName: "edit-service" */ "@/view/crud/Tools/edit.vue"
          ),
        meta: {
          breadcrumb: (route) => `menu.EditTool:${route.params.id}`,
          breadcrumbIcon: "edit",
        },
      },
      {
        path: "add/",
        name: "tools-add",
        component: () =>
          import(
            /* webpackChunkName: "Tools-add" */ "@/view/crud/Tools/addNew.vue"
          ),
        meta: {
          breadcrumb: "menu.AddNew",
          breadcrumbIcon: "plus",
        },
      },
    ],
  },

  {
    path: "/WorkerCourses/:user_id/",
    meta: {
      breadcrumb: (route) => `menu.CoursesForUser:${route.params.user_id}`, // Dynamic i18n key
      breadcrumbIcon: "user-graduate", // Unicon icon: 'user-graduate'
    },
    component: () =>
      import(
        /* webpackChunkName: "axios" */ "@/view/crud/WorkerCourses/Index.vue"
      ),
    children: [
      {
        path: "view",
        name: "workercourses-view",
        component: () =>
          import(
            /* webpackChunkName: "WorkerCourses" */ "@/view/crud/WorkerCourses/View.vue"
          ),
        meta: {
          breadcrumb: "menu.ViewAll",
        },
      },
      {
        path: "edit/:id",
        name: "workercourses-edit",
        component: () =>
          import(
            /* webpackChunkName: "edit-service" */ "@/view/crud/WorkerCourses/edit.vue"
          ),
        meta: {
          breadcrumb: (route) => `menu.EditWorkerCourse:${route.params.id}`,
          breadcrumbIcon: "edit",
        },
      },
      {
        path: "add/",
        name: "workercourses-add",
        component: () =>
          import(
            /* webpackChunkName: "WorkerCourses-add" */ "@/view/crud/WorkerCourses/addNew.vue"
          ),
        meta: {
          breadcrumb: "menu.AddNew",
          breadcrumbIcon: "plus",
        },
      },
    ],
  },

  {
    path: "/WorkerTools/:user_id/",
    meta: {
      breadcrumb: (route) => `menu.CoursesForUser:${route.params.user_id}`, // Dynamic i18n key
      breadcrumbIcon: "user-graduate", // Unicon icon: 'user-graduate'
    },
    component: () =>
      import(
        /* webpackChunkName: "axios" */ "@/view/crud/WorkerTools/Index.vue"
      ),
    children: [
      {
        path: "view",
        name: "WorkerTools-view",
        component: () =>
          import(
            /* webpackChunkName: "WorkerCourses" */ "@/view/crud/WorkerTools/View.vue"
          ),
        meta: {
          breadcrumb: "menu.ViewAll",
        },
      },
      {
        path: "edit/:id",
        name: "WorkerTools-edit",
        component: () =>
          import(
            /* webpackChunkName: "edit-service" */ "@/view/crud/WorkerTools/edit.vue"
          ),
        meta: {
          breadcrumb: (route) => `menu.EditWorkerCourse:${route.params.id}`,
          breadcrumbIcon: "edit",
        },
      },
      {
        path: "add/",
        name: "WorkerTools-add",
        component: () =>
          import(
            /* webpackChunkName: "WorkerCourses-add" */ "@/view/crud/WorkerTools/addNew.vue"
          ),
        meta: {
          breadcrumb: "menu.AddNew",
          breadcrumbIcon: "plus",
        },
      },
    ],
  },

  {
    path: "/users",
    meta: {
      breadcrumb: "menu.Users", // Use i18n key for Users
      breadcrumbIcon: "users", // Unicon icon: 'users'
    },
    component: () =>
      import(/* webpackChunkName: "axios" */ "@/view/crud/users/Index.vue"),
    children: [
      {
        path: "view",
        name: "users-view",
        component: () =>
          import(/* webpackChunkName: "users" */ "@/view/crud/users/View.vue"),
        meta: {
          breadcrumb: "menu.ViewAll",
        },
      },
      {
        path: "edit/:id",
        name: "users-edit",
        component: () =>
          import(
            /* webpackChunkName: "edit-service" */ "@/view/crud/users/edit.vue"
          ),
        meta: {
          breadcrumb: (route) => `menu.EditUser:${route.params.id}`,
          breadcrumbIcon: "edit",
        },
      },
      {
        path: "add",
        name: "users-add",
        component: () =>
          import(
            /* webpackChunkName: "users-add" */ "@/view/crud/users/addNew.vue"
          ),
        meta: {
          breadcrumb: "menu.AddNew",
          breadcrumbIcon: "plus",
        },
      },
    ],
  },

  {
    path: "/staff",
    meta: {
      breadcrumb: "menu.staff", // Use i18n key for Users
      breadcrumbIcon: "users", // Unicon icon: 'users'
    },
    component: () =>
      import(/* webpackChunkName: "axios" */ "@/view/crud/Staff/Index.vue"),
    children: [
      {
        path: "view",
        name: "staff-view",
        component: () =>
          import(/* webpackChunkName: "staff" */ "@/view/crud/Staff/View.vue"),
        meta: {
          breadcrumb: "menu.ViewAll",
        },
      },
      {
        path: "edit/:id",
        name: "staff-edit",
        component: () =>
          import(
            /* webpackChunkName: "edit-service" */ "@/view/crud/Staff/edit.vue"
          ),
        meta: {
          breadcrumb: (route) => `menu.EditUser:${route.params.id}`,
          breadcrumbIcon: "edit",
        },
      },
      {
        path: "add",
        name: "staff-add",
        component: () =>
          import(
            /* webpackChunkName: "staff-add" */ "@/view/crud/Staff/addNew.vue"
          ),
        meta: {
          breadcrumb: "menu.AddNew",
          breadcrumbIcon: "plus",
        },
      },
    ],
  },
];

export default routes;
